import React from 'react'
import cn from 'classnames'

import { get } from 'lodash'
import Icon from '@scoir/components-core/dist/components/Icon'
import VirtualVisitInverted from '@scoir/brand-icons/dist/VirtualVisitInverted'
import ProfileSecondary from '@scoir/brand-icons/dist/ProfileSecondary'

import slotIcon from 'icons/filter-none.svg'
import { isShortDuration } from '../durationHelper'
import CollegeVisit from '.'
import requiredPropTypes from './requiredPropTypes'

export default function WeekView(props) {
  const isMultiEvent = get(props.event, 'Type') === 'multi'
  const isVirtual = get(props.event, 'Virtual', false)
  return (
    <CollegeVisit
      {...props}
      className={cn('week', {
        'short-duration': isShortDuration(props.event),
      })}
      summary={
        <React.Fragment>
          <span className="student-count pull-right">
            <ProfileSecondary
              size="xs"
              className="profile-icon"
            />
            {props.event.NumAttendees}
          </span>
          {isVirtual ? (
            <div>
              <strong>
                Virtual High School Visit <VirtualVisitInverted />
              </strong>
            </div>
          ) : (
            <div>
              <strong>High School Visit</strong>
            </div>
          )}
          <div className="high-school-name">
            {isMultiEvent && (
              <Icon
                className="slot-icon"
                def={slotIcon}
                size="xs"
                beforeText
              />
            )}
            <span>{props.event.HighSchoolName}</span>
          </div>
        </React.Fragment>
      }
    />
  )
}
WeekView.propTypes = requiredPropTypes
